import { useStoreon } from 'storeon/react';
import { EKeycardType, LoyaltyRegistrationModalStore } from '../../../reducers';
import { useEffectOnce } from 'common/hooks';
import { REGISTRATION_MODAL } from '../../../actions';
import { sendShowLoyaltyRegistrationModalEvent } from 'utils/ga-events';

export const OPEN_LOYALTY_REGISTRATION_MODAL_EVENT = 'OPEN_LOYALTY_REGISTRATION_MODAL';

export interface IOpenLoyaltyRegistrationModalEventDetails {
  from: string;
  preselectCard: EKeycardType;
}

export const useLoyaltyRegistrationModalEvents = () => {
  const { dispatch } = useStoreon<LoyaltyRegistrationModalStore>('loyaltyRegistrationModal');

  const openModal = (ev: Event) => {
    const details = (ev as CustomEvent<IOpenLoyaltyRegistrationModalEventDetails>).detail;

    if (details.preselectCard) {
      if ([EKeycardType.HOME, EKeycardType.PRO].includes(details.preselectCard)) {
        dispatch(REGISTRATION_MODAL.setPreselectCard, { preselectCard: details.preselectCard });
      }
    }

    dispatch(REGISTRATION_MODAL.open);

    if (details.from) {
      dispatch(REGISTRATION_MODAL.setModalOpenFrom, { from: details.from });
      sendShowLoyaltyRegistrationModalEvent(details.from);
    }
  };

  useEffectOnce(() => {
    window.addEventListener(OPEN_LOYALTY_REGISTRATION_MODAL_EVENT, openModal);

    return () => {
      window.removeEventListener(OPEN_LOYALTY_REGISTRATION_MODAL_EVENT, openModal);
    };
  });

  // HACK: Для юнит тестов
  return {
    openModal,
  };
};
